import React from "react";
import CircularProgressBar from "../Common/CirclularProgressBar";

const PieChart = ({ variant = "fulldonut", data }) => {
  return (
    <div className="flex justify-center items-center">
      <CircularProgressBar data={data} variant={variant} />
    </div>
  );
};

export default PieChart;
